import breakpoints from 'styles/breakpoints.module.css';

export const mobile = parseInt(breakpoints.widthMobile);
export const wide = parseInt(breakpoints.widthWide);
